/**
 * Component: Search Form
 * ------------------------------------------------------------------------------
 * Functions to control Search form eg valitation.
 *
 * @namespace searchForm
 */
import log from 'salvo-lite/log'
import {on} from '../helpers/utils'

class SearchForm {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            searchInput: '[data-search="input"]',
            searchBtn: '[data-search="button"]',
            searchHeader: '[js-search-location="header"]',
            ...JSON.parse(elem.getAttribute('data-search-form') || '{}')
        }
        this._nodeSelectors = {
            searchHeader: document.querySelectorAll(this._settings.searchHeader)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        this._validateEmptySearch()
        this._registerObserver(this._nodeSelectors.searchHeader)
    }

    /**
     * Validate search toggle field.
     */
    _validateEmptySearch () {
        const searchInput = this._elem.querySelector(this._settings.searchInput)
        on('keyup', searchInput, (event) => this._handleSubmitEvent(event, searchInput, this._elem))
        on('focus', searchInput, () => {
            const end = searchInput.value.length
            searchInput.setSelectionRange(end, end)
            searchInput.focus()
        })
    }

    /**
     * Handle search submit event.
     */
    _handleSubmitEvent (event, element, parent) {
        const searchBtn = parent.querySelector(this._settings.searchBtn)
        /* eslint-disable-next-line */
        const specialChars = `/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;`
        const isSpecialCharsPresent = specialChars.split('').some(char => element.value.includes(char))
        if (event.keyCode === 13 && element.value.length < 0) {
            event.preventDefault()
        } else if (isSpecialCharsPresent) {
            searchBtn.removeAttribute('disabled')
            on('keydown', searchBtn, (event) => {
                element.value = element.value.replace(/[^\w ]/g, '')
            })
            on('click', searchBtn, (event) => {
                element.value = element.value.replace(/[^\w ]/g, '')
            })
        } else if (element.value.length > 0) {
            searchBtn.removeAttribute('disabled')
        } else {
            searchBtn.setAttribute('disabled', 'disabled')
        }
    }

    /**
     * observer for focusing the header search bar once inline search bar is clicked
     */
    _registerObserver (element) {
        var observer = new MutationObserver(function (observer) {
            if (element[0].classList.contains('is-active')) {
                const element = document.querySelector('[data-klevu-search-input]')
                if (element) {
                    element.focus()
                    observer.disconnect()
                }
            }
        })
        observer.observe(element[0], { attributes: true, childList: true })
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // });
}

export default SearchForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SearchForm.js